/*
  Cosmoshop custom behaviour layer
  --------------------------------
  Store-specific JavaScript lives here instead of inline in Liquid sections.
*/
(function() {
  'use strict';
  var CONTRAST_THRESHOLD = 0.55;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function debounce(callback, delay) {
    var timer;
    return function() {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function() {
        callback.apply(null, args);
      }, delay);
    };
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

/* Collection sort dropdown ------------------------------------------- */
  function closeSortDropdowns(exceptWidget) {
    document.querySelectorAll('[data-collection-sort].is-open').forEach(function(widget) {
      if (widget === exceptWidget) return;
      widget.classList.remove('is-open');
      var button = widget.querySelector('.collection-sort-custom__button');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleSortDropdown(widget) {
    if (!widget) return;
    var willOpen = !widget.classList.contains('is-open');
    closeSortDropdowns(widget);
    widget.classList.toggle('is-open', willOpen);
    var button = widget.querySelector('.collection-sort-custom__button');
    if (button) button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function initCollectionSort() {
    if (document.documentElement.dataset.cosmoshopCollectionSortReady === 'true') return;
    document.documentElement.dataset.cosmoshopCollectionSortReady = 'true';

    document.addEventListener('click', function(event) {
      var toggleButton = event.target.closest('.collection-sort-custom__button');
      if (toggleButton) {
        event.preventDefault();
        toggleSortDropdown(toggleButton.closest('[data-collection-sort]'));
        return;
      }

      var optionButton = event.target.closest('.collection-sort-custom__option');
      if (optionButton) {
        event.preventDefault();

        var widget = optionButton.closest('[data-collection-sort]');
        var form = optionButton.closest('form');
        var select = form ? form.querySelector('select[name="sort_by"]') : null;
        var valueLabel = widget ? widget.querySelector('.collection-sort-custom__value') : null;
        var selectedValue = optionButton.getAttribute('data-sort-value');

        if (select && selectedValue) select.value = selectedValue;
        if (valueLabel) valueLabel.textContent = optionButton.textContent.trim();

        if (widget) {
          widget.querySelectorAll('.collection-sort-custom__option').forEach(function(button) {
            var isSelected = button === optionButton;
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          });
          closeSortDropdowns();
        }

        if (form) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
        return;
      }

      if (!event.target.closest('[data-collection-sort]')) closeSortDropdowns();
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') closeSortDropdowns();
    });
  }

  /* Slideshow ------------------------------------------------------------ */
  function whenImageReady(img, callback) {
    if (!img) return;
    if (img.complete && img.naturalWidth && img.naturalHeight) {
      callback();
    } else {
      img.addEventListener('load', callback, { once: true });
    }
  }

  function reserveImageAspectRatios(slider) {
    slider.querySelectorAll('img').forEach(function(img) {
      whenImageReady(img, function() {
        if (img.naturalWidth && img.naturalHeight) {
          img.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
        }
      });
    });
  }

  function getActiveSlideImage(slider) {
    return slider.querySelector('.slides > li.flex-active-slide img') ||
      slider.querySelector('.slides > li:not(.clone) img') ||
      slider.querySelector('.slides img');
  }

  function getScaledCanvas(img) {
    var naturalWidth = img.naturalWidth;
    var naturalHeight = img.naturalHeight;
    if (!naturalWidth || !naturalHeight) return null;

    var canvasWidth = 260;
    var canvasHeight = Math.max(1, Math.round((naturalHeight / naturalWidth) * canvasWidth));
    var cacheKey = canvasWidth + 'x' + canvasHeight + ':' + img.currentSrc;

    if (img._cosmoContrastCache && img._cosmoContrastCache.key === cacheKey) {
      return img._cosmoContrastCache;
    }

    var canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;

    try {
      ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);
    } catch (error) {
      return null;
    }

    img._cosmoContrastCache = { key: cacheKey, canvas: canvas, ctx: ctx };
    return img._cosmoContrastCache;
  }

  function getAverageLuminance(img, button) {
    var imageRect = img.getBoundingClientRect();
    var buttonRect = button.getBoundingClientRect();
    var scaled = getScaledCanvas(img);
    if (!scaled || !imageRect.width || !imageRect.height) return null;

    var relativeX = ((buttonRect.left + (buttonRect.width / 2)) - imageRect.left) / imageRect.width;
    var relativeY = ((buttonRect.top + (buttonRect.height / 2)) - imageRect.top) / imageRect.height;
    var x = clamp(Math.round(relativeX * scaled.canvas.width), 0, scaled.canvas.width - 1);
    var y = clamp(Math.round(relativeY * scaled.canvas.height), 0, scaled.canvas.height - 1);
    var radius = 10;
    var sx = clamp(x - radius, 0, scaled.canvas.width - 1);
    var sy = clamp(y - radius, 0, scaled.canvas.height - 1);
    var sw = clamp((radius * 2) + 1, 1, scaled.canvas.width - sx);
    var sh = clamp((radius * 2) + 1, 1, scaled.canvas.height - sy);

    try {
      var data = scaled.ctx.getImageData(sx, sy, sw, sh).data;
      var r = 0;
      var g = 0;
      var b = 0;
      var count = 0;

      for (var i = 0; i < data.length; i += 4) {
        var alpha = data[i + 3];
        if (alpha < 10) continue;
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        count += 1;
      }

      if (!count) return null;
      r = r / count;
      g = g / count;
      b = b / count;

      return ((0.2126 * r) + (0.7152 * g) + (0.0722 * b)) / 255;
    } catch (error) {
      return null;
    }
  }

  function setArrowContrast(slider, img, selector, colorVar, shadowVar) {
    var button = slider.querySelector(selector);
    if (!button) return false;

    var luminance = getAverageLuminance(img, button);
    if (luminance === null) return false;

    var useWhite = luminance < CONTRAST_THRESHOLD;
    slider.style.setProperty(colorVar, useWhite ? '#ffffff' : '#000000');
    slider.style.setProperty(shadowVar, useWhite ? 'rgba(0, 0, 0, 0.55)' : 'rgba(255, 255, 255, 0.7)');
    return true;
  }

  function initSlideshow(slider) {
    if (!slider || slider.dataset.cosmoshopSlideshowReady === 'true') return;
    slider.dataset.cosmoshopSlideshowReady = 'true';

    reserveImageAspectRatios(slider);

    /* Keep the hero pagination indicators proportional to the rendered banner,
       but use the same elongated pill shape as the product-media pagination. */
    function syncHeroPaginationDotSize() {
      var width = slider.getBoundingClientRect().width || slider.clientWidth || 0;
      if (!width) return;
      var indicatorWidth = Math.min(20, Math.max(12, width / 36));
      var indicatorHeight = Math.min(4, Math.max(3, width / 180));
      slider.style.setProperty('--cosmoshop-hero-dot-width', indicatorWidth.toFixed(2) + 'px');
      slider.style.setProperty('--cosmoshop-hero-dot-height', indicatorHeight.toFixed(2) + 'px');
    }

    syncHeroPaginationDotSize();

    function updateArrowContrast() {
      var img = getActiveSlideImage(slider);
      if (!img) return;

      whenImageReady(img, function() {
        var previousUpdated = setArrowContrast(slider, img, '.flex-direction-nav .flex-prev', '--slider-prev-arrow-color', '--slider-prev-arrow-shadow');
        var nextUpdated = setArrowContrast(slider, img, '.flex-direction-nav .flex-next', '--slider-next-arrow-color', '--slider-next-arrow-shadow');

        if (previousUpdated || nextUpdated) {
          slider.dataset.arrowContrastReady = 'true';
        }
      });
    }

    function moveSlider(direction) {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flexslider) return;
      window.jQuery(slider).flexslider(direction);
      window.setTimeout(updateArrowContrast, 80);
    }

    function refreshSliderLayout() {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flexslider) return;

      var $slider = window.jQuery(slider);
      var flexslider = $slider.data('flexslider');
      if (!flexslider || flexslider.animating || !flexslider.viewport || !flexslider.newSlides) return;

      var viewportWidth = Math.round(window.jQuery(flexslider.viewport).width() || slider.clientWidth || 0);
      if (!viewportWidth) return;

      flexslider.w = viewportWidth;
      flexslider.itemW = viewportWidth;
      flexslider.itemM = flexslider.vars ? flexslider.vars.itemMargin : 0;
      flexslider.boxPadding = 0;
      flexslider.computedW = viewportWidth;
      flexslider.computedM = flexslider.itemM || 0;

      flexslider.newSlides.css({
        width: flexslider.computedW,
        marginRight: flexslider.computedM,
        float: 'left',
        display: 'block'
      });

      if (typeof flexslider.setProps === 'function') {
        flexslider.setProps(flexslider.computedW, 'setTotal');
      }

      if (flexslider.vars && flexslider.vars.smoothHeight && flexslider.viewport && flexslider.slides) {
        window.jQuery(flexslider.viewport).height(flexslider.slides.eq(flexslider.animatingTo || flexslider.currentSlide || 0).innerHeight());
      }
    }

    function scheduleSliderLayoutRefresh() {
      window.requestAnimationFrame(function() {
        refreshSliderLayout();
        syncHeroPaginationDotSize();
        updateArrowContrast();
      });
    }

    function enableImageSwipe() {
      if (slider.dataset.swipeReady === 'true') return;
      slider.dataset.swipeReady = 'true';

      var heroSwipeMediaQuery = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
      function canSwipeHeroImage() {
        return heroSwipeMediaQuery ? heroSwipeMediaQuery.matches : window.innerWidth < 990;
      }

      var ignoredSelector = 'button, input, textarea, select, label, .slideshow-text, .flex-direction-nav, .flex-control-nav';
      var active = false;
      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastY = 0;
      var suppressSlideLinkClickUntil = 0;

      function shouldIgnoreSwipe(target) {
        if (!target || !target.closest) return false;
        if (target.closest('.tm-slideshow__media-link')) return false;
        return Boolean(target.closest(ignoredSelector));
      }

      function startSwipe(clientX, clientY) {
        active = true;
        startX = clientX;
        startY = clientY;
        lastX = clientX;
        lastY = clientY;
        slider.classList.add('is-dragging');
      }

      function finishSwipe(event) {
        if (!active) return;

        var dx = lastX - startX;
        var dy = lastY - startY;
        var threshold = clamp(slider.clientWidth * 0.08, 40, 120);
        var movedBeyondClick = Math.abs(dx) > 8 || Math.abs(dy) > 8;
        var isHorizontalSwipe = Math.abs(dx) > threshold && Math.abs(dx) > (Math.abs(dy) * 1.25);

        if (movedBeyondClick) {
          suppressSlideLinkClickUntil = Date.now() + 500;
        }

        active = false;
        pointerId = null;
        slider.classList.remove('is-dragging');

        if (!isHorizontalSwipe) return;

        if (event && event.cancelable) event.preventDefault();
        moveSlider(dx < 0 ? 'next' : 'prev');
      }

      slider.addEventListener('click', function(event) {
        var link = event.target && event.target.closest ? event.target.closest('.tm-slideshow__media-link') : null;
        if (!link) return;

        if (Date.now() < suppressSlideLinkClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      if (window.PointerEvent) {
        slider.addEventListener('pointerdown', function(event) {
          if (!canSwipeHeroImage()) return;
          if (shouldIgnoreSwipe(event.target)) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          pointerId = event.pointerId;
          startSwipe(event.clientX, event.clientY);
          if (slider.setPointerCapture) slider.setPointerCapture(pointerId);
        });

        slider.addEventListener('pointermove', function(event) {
          if (!active || event.pointerId !== pointerId) return;
          if (!canSwipeHeroImage()) {
            active = false;
            pointerId = null;
            slider.classList.remove('is-dragging');
            return;
          }
          lastX = event.clientX;
          lastY = event.clientY;
          var dx = lastX - startX;
          var dy = lastY - startY;
          if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) && event.cancelable) {
            event.preventDefault();
          }
        }, { passive: false });

        slider.addEventListener('pointerup', finishSwipe, { passive: false });
        slider.addEventListener('pointercancel', function() {
          active = false;
          pointerId = null;
          slider.classList.remove('is-dragging');
        });
      } else {
        slider.addEventListener('touchstart', function(event) {
          if (!canSwipeHeroImage()) return;
          if (event.touches.length !== 1 || shouldIgnoreSwipe(event.target)) return;
          startSwipe(event.touches[0].clientX, event.touches[0].clientY);
        }, { passive: true });

        slider.addEventListener('touchmove', function(event) {
          if (!active || event.touches.length !== 1) return;
          if (!canSwipeHeroImage()) {
            active = false;
            slider.classList.remove('is-dragging');
            return;
          }
          lastX = event.touches[0].clientX;
          lastY = event.touches[0].clientY;
          var dx = lastX - startX;
          var dy = lastY - startY;
          if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) && event.cancelable) {
            event.preventDefault();
          }
        }, { passive: false });

        slider.addEventListener('touchend', finishSwipe, { passive: false });
        slider.addEventListener('touchcancel', function() {
          active = false;
          slider.classList.remove('is-dragging');
        });
      }
    }

    function configureHeroPaginationButtons() {
      var pagination = slider.querySelector('.flex-control-nav');
      if (!pagination) return;

      pagination.removeAttribute('aria-hidden');
      pagination.querySelectorAll('a').forEach(function(control, index) {
        control.removeAttribute('aria-disabled');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        control.setAttribute('aria-current', control.classList.contains('flex-active') ? 'true' : 'false');
      });
    }

    function startFlexslider() {
      if (slider.dataset.ready === 'true') return;

      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.flexslider) {
        window.setTimeout(startFlexslider, 50);
        return;
      }

      slider.dataset.ready = 'true';
      window.jQuery(slider).flexslider({
        animation: 'slide',
        controlNav: true,
        directionNav: false,
        animationSpeed: 340,
        slideshow: false,
        touch: false,
        pauseOnHover: true,
        useCSS: true,
        smoothHeight: false,
        start: function() {
          configureHeroPaginationButtons();
          enableImageSwipe();
          scheduleSliderLayoutRefresh();
        },
        after: function() {
          configureHeroPaginationButtons();
          scheduleSliderLayoutRefresh();
        }
      });
    }

    var resizeRefresh = debounce(scheduleSliderLayoutRefresh, 150);
    window.addEventListener('resize', resizeRefresh, { passive: true });
    window.addEventListener('orientationchange', function() {
      window.setTimeout(scheduleSliderLayoutRefresh, 250);
    });

    slider.querySelectorAll('img').forEach(function(img) {
      img.addEventListener('load', scheduleSliderLayoutRefresh, { once: true });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            startFlexslider();
            observer.disconnect();
          }
        });
      }, { rootMargin: '200px 0px' });
      observer.observe(slider);
    } else {
      startFlexslider();
    }
  }


  function initMobileDrawerStacking() {
    var drawers = document.querySelectorAll('#shopify-section-header .menu-drawer-container');
    if (!drawers.length) return;

    function updateMobileDrawerViewportOffset() {
      var headerWrapper = document.querySelector('#shopify-section-header > .cosmoshop-header-wrapper');
      var height = headerWrapper ? Math.round(headerWrapper.getBoundingClientRect().height || headerWrapper.offsetHeight || 0) : 0;
      if (!height) height = 76;
      document.documentElement.style.setProperty('--cosmoshop-mobile-menu-top', height + 'px');
    }

    function lockHeaderDrawerScroll() {
      if (window.CosmoshopSmartHeader && typeof window.CosmoshopSmartHeader.show === 'function') {
        window.CosmoshopSmartHeader.show();
      }

      updateMobileDrawerViewportOffset();
      document.documentElement.classList.add('cosmoshop-header-menu-scroll-locked');
      document.body.classList.add('cosmoshop-header-menu-scroll-locked');

      /* Do not use position:fixed + negative top here. The smart header is
         fixed independently, and offsetting the body would move the whole
         header/drawer subtree by the page scroll amount. */
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
    }

    function unlockHeaderDrawerScroll() {
      if (!document.body.classList.contains('cosmoshop-header-menu-scroll-locked')) return;

      document.documentElement.classList.remove('cosmoshop-header-menu-scroll-locked');
      document.body.classList.remove('cosmoshop-header-menu-scroll-locked');
      document.documentElement.style.removeProperty('--cosmoshop-mobile-menu-top');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
    }

    drawers.forEach(function(drawer) {
      if (drawer.dataset.cosmoshopStackingReady === 'true') return;
      drawer.dataset.cosmoshopStackingReady = 'true';

      var topMenu = drawer.closest('.cosmoshop-header__menu-slot');
      var summary = drawer.querySelector('summary.header__icon--menu');
      var panel = drawer.querySelector('.cosmoshop-header-drawer__panel');
      var touchStartY = 0;
      var portalHost = null;

      function mountDrawerPanelToViewport() {
        if (!panel || !isCosmoshopMobileMenu()) return;
        var headerSection = document.getElementById('shopify-section-header');
        if (!headerSection) return;

        if (!portalHost) {
          portalHost = document.createElement('div');
          portalHost.className = 'cosmoshop-header-drawer cosmoshop-mobile-menu-portal-host';
        }

        if (!portalHost.parentNode) headerSection.appendChild(portalHost);
        if (panel.parentNode !== portalHost) portalHost.appendChild(panel);
        panel.classList.add('cosmoshop-mobile-menu-portal-panel');
      }

      function restoreDrawerPanel() {
        if (!panel) return;
        panel.classList.remove('cosmoshop-mobile-menu-portal-panel', 'cosmoshop-mobile-menu-portal-panel--closing');
        if (panel.parentNode !== drawer) drawer.appendChild(panel);
        if (portalHost && portalHost.parentNode) portalHost.parentNode.removeChild(portalHost);
      }

      function isCosmoshopMobileMenu() {
        return window.matchMedia && window.matchMedia('(max-width: 1023.98px)').matches;
      }

      function isDrawerVisible() {
        return drawer.hasAttribute('open') || drawer.classList.contains('menu-opening') || drawer.classList.contains('cosmoshop-menu-closing');
      }

      function closeCosmoshopMobileMenu(event) {
        if (!isCosmoshopMobileMenu()) return;
        if (!drawer.hasAttribute('open') && !drawer.classList.contains('menu-opening')) return;
        if (drawer.classList.contains('cosmoshop-menu-closing')) return;

        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        if (panel) panel.classList.add('cosmoshop-mobile-menu-portal-panel--closing');
        drawer.classList.add('cosmoshop-menu-closing');
        drawer.classList.remove('menu-opening');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        syncDrawerStacking();

        window.setTimeout(function() {
          restoreDrawerPanel();
          drawer.classList.remove('cosmoshop-menu-closing');
          drawer.removeAttribute('open');
          if (topMenu) topMenu.classList.remove('cosmoshop-drawer-front');
          document.body.classList.remove('overflow-hidden-mobile', 'cosmoshop-header-drawer-open');
          unlockHeaderDrawerScroll();
        }, 300);
      }

      if (summary && summary.dataset.cosmoshopSlideCloseReady !== 'true') {
        summary.dataset.cosmoshopSlideCloseReady = 'true';
        summary.addEventListener('click', closeCosmoshopMobileMenu, true);
      }

      function syncDrawerStacking() {
        var isOpen = isDrawerVisible();
        if (isOpen) mountDrawerPanelToViewport();
        if (topMenu) topMenu.classList.toggle('cosmoshop-drawer-front', isOpen);
        document.body.classList.toggle('cosmoshop-header-drawer-open', isOpen);
        if (isOpen) {
          if (panel && !drawer.classList.contains('cosmoshop-menu-closing')) {
            panel.classList.remove('cosmoshop-mobile-menu-portal-panel--closing');
          }
          lockHeaderDrawerScroll();
        } else {
          restoreDrawerPanel();
          unlockHeaderDrawerScroll();
        }
      }

      syncDrawerStacking();
      drawer.addEventListener('toggle', syncDrawerStacking);

      var overlay = drawer.querySelector('.menu_overlay');
      if (overlay && overlay.dataset.cosmoshopOverlayCloseReady !== 'true') {
        overlay.dataset.cosmoshopOverlayCloseReady = 'true';
        overlay.addEventListener('click', closeCosmoshopMobileMenu);
      }

      if (panel && panel.dataset.cosmoshopScrollGuardReady !== 'true') {
        panel.dataset.cosmoshopScrollGuardReady = 'true';

        panel.addEventListener('touchstart', function(event) {
          if (!event.touches || !event.touches.length) return;
          touchStartY = event.touches[0].clientY;
        }, { passive: true });

        panel.addEventListener('touchmove', function(event) {
          if (!isDrawerVisible()) return;
          if (!event.touches || !event.touches.length) return;

          var currentY = event.touches[0].clientY;
          var deltaY = currentY - touchStartY;
          var maxScrollTop = panel.scrollHeight - panel.clientHeight;

          if (maxScrollTop <= 0) {
            event.preventDefault();
            return;
          }

          if ((panel.scrollTop <= 0 && deltaY > 0) || (panel.scrollTop >= maxScrollTop - 1 && deltaY < 0)) {
            event.preventDefault();
          }
        }, { passive: false });

        panel.addEventListener('wheel', function(event) {
          if (!isDrawerVisible()) return;

          var maxScrollTop = panel.scrollHeight - panel.clientHeight;
          if (maxScrollTop <= 0) {
            event.preventDefault();
            return;
          }

          if ((panel.scrollTop <= 0 && event.deltaY < 0) || (panel.scrollTop >= maxScrollTop - 1 && event.deltaY > 0)) {
            event.preventDefault();
          }
        }, { passive: false });
      }

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(syncDrawerStacking);
        observer.observe(drawer, { attributes: true, attributeFilter: ['open', 'class'] });
      }
    });

    if (!window.__cosmoshopMobileDrawerViewportResizeReady) {
      window.__cosmoshopMobileDrawerViewportResizeReady = true;
      var refreshDrawerOffset = function() {
        if (document.body.classList.contains('cosmoshop-header-drawer-open')) {
          updateMobileDrawerViewportOffset();
        }
      };
      window.addEventListener('resize', refreshDrawerOffset, { passive: true });
      window.addEventListener('orientationchange', refreshDrawerOffset, { passive: true });
    }
  }



  function initMobileSearchStacking() {
    var searchDetails = document.querySelectorAll('#shopify-section-header details-modal.header__search details');
    if (!searchDetails.length) return;

    function syncSearchStacking() {
      var isOpen = Array.prototype.some.call(searchDetails, function(details) {
        return details.hasAttribute('open');
      });
      document.body.classList.toggle('cosmoshop-search-open', isOpen);

      if (isOpen) {
        var header = document.getElementById('shopify-section-header');
        if (header) {
          header.classList.add('shopify-section-header-sticky', 'animate');
          header.classList.remove('shopify-section-header-hidden');
        }
      }
    }

    searchDetails.forEach(function(details) {
      if (details.dataset.cosmoshopSearchStackingReady === 'true') return;
      details.dataset.cosmoshopSearchStackingReady = 'true';
      details.addEventListener('toggle', syncSearchStacking);

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(syncSearchStacking);
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') window.setTimeout(syncSearchStacking, 0);
    });
    document.addEventListener('click', function() {
      window.setTimeout(syncSearchStacking, 0);
    });

    syncSearchStacking();
  }




  function initCosmoshopStickyHeaderRestore() {
    var header = document.getElementById('shopify-section-header');
    if (!header || header.dataset.cosmoshopStickyRestoreReady === 'true') return;
    header.dataset.cosmoshopStickyRestoreReady = 'true';

    var lastScrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    var upwardTravel = 0;
    var downwardTravel = 0;
    var revealThreshold = 2;
    var hideThreshold = 12;
    var hideAfter = 90;
    var ticking = false;

    function isActualSearchOpen() {
      return Boolean(document.querySelector('#shopify-section-header details-modal.header__search details[open]'));
    }

    function isMenuOrCartOpen() {
      return Boolean(document.querySelector('#shopify-section-header .cosmoshop-header-drawer[open]')) ||
        document.body.classList.contains('cosmoshop-header-drawer-open') ||
        document.body.classList.contains('cosmoshop-cart-open') ||
        document.documentElement.classList.contains('cosmoshop-cart-open');
    }

    function reveal() {
      header.classList.add('shopify-section-header-sticky', 'animate');
      header.classList.remove('shopify-section-header-hidden');
    }

    function hide() {
      header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    function reset() {
      header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    function handleScroll() {
      var scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      var delta = scrollTop - lastScrollTop;

      if (!isActualSearchOpen()) {
        document.body.classList.remove('cosmoshop-search-open');
      }

      if (isActualSearchOpen() || isMenuOrCartOpen()) {
        reveal();
        lastScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= 0) {
        reset();
        lastScrollTop = scrollTop;
        return;
      }

      if (delta < 0) {
        upwardTravel += Math.abs(delta);
        downwardTravel = 0;

        if (upwardTravel >= revealThreshold) {
          reveal();
          upwardTravel = 0;
        }
      } else if (delta > 0) {
        downwardTravel += delta;
        upwardTravel = 0;

        if (downwardTravel >= hideThreshold && scrollTop > hideAfter) {
          hide();
          downwardTravel = 0;
        }
      }

      lastScrollTop = scrollTop;
    }

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
    }, { passive: true });
  }


  function initCosmoshopSearchPlaceholder() {
    document.querySelectorAll('#shopify-section-header input[type="search"], #shopify-section-header .search__input').forEach(function(input) {
      input.setAttribute('placeholder', 'SEARCH FOR...');
    });
  }

  function initSlideshows() {
    document.querySelectorAll('#tm-flexslider').forEach(initSlideshow);
  }


  function initCosmoshopProductCountProgress() {
    function getCurrentPage() {
      try {
        var params = new URLSearchParams(window.location.search || '');
        var page = parseInt(params.get('page') || '1', 10);
        return isNaN(page) || page < 1 ? 1 : page;
      } catch (error) {
        return 1;
      }
    }

    function updateCount() {
      var countEl = document.querySelector('#main-collection-filters #ProductCount');
      if (!countEl) return;

      var totalMatch = (countEl.textContent || '').match(/of\s+(\d+)/i);
      var total = totalMatch ? parseInt(totalMatch[1], 10) : NaN;
      if (isNaN(total)) {
        total = parseInt(countEl.getAttribute('data-total-results') || '', 10);
      }
      if (isNaN(total)) return;

      var pageSize = parseInt(countEl.getAttribute('data-products-per-page') || '', 10);
      if (isNaN(pageSize) || pageSize <= 0) {
        var shownMatch = (countEl.textContent || '').match(/^\s*(\d+)/);
        pageSize = shownMatch ? parseInt(shownMatch[1], 10) : 0;
      }
      if (!pageSize) return;

      var currentPage = getCurrentPage();
      var visibleProducts = document.querySelectorAll('#ProductGridContainer #product-grid > .grid__item').length;
      if (!visibleProducts) visibleProducts = Math.min(pageSize, total);

      var shown = ((currentPage - 1) * pageSize) + visibleProducts;
      if (shown > total) shown = total;
      if (shown < 0) shown = 0;

      countEl.textContent = shown + ' of ' + total;
    }

    window.cosmoshopUpdateProductCountProgress = updateCount;

    updateCount();

    document.addEventListener('shopify:section:load', updateCount);
    window.addEventListener('popstate', function() {
      window.setTimeout(updateCount, 50);
    });

    document.addEventListener('click', function(event) {
      if (event.target.closest('.pagination-wrapper a, .pagination a')) {
        window.setTimeout(updateCount, 250);
        window.setTimeout(updateCount, 700);
      }
    }, true);

    var grid = document.querySelector('#ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function() {
        window.setTimeout(updateCount, 50);
      }).observe(grid, { childList: true, subtree: true });
    }
  }


  function initCosmoshopStickyHeaderRestoreV2() {
    var header = document.getElementById('shopify-section-header');
    if (!header || header.dataset.cosmoshopStickyRestoreV2Ready === 'true') return;
    header.dataset.cosmoshopStickyRestoreV2Ready = 'true';

    var lastY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    var threshold = 4;
    var hideAfter = 80;
    var ticking = false;

    function isLockedOpen() {
      return Boolean(
        document.querySelector('#shopify-section-header details-modal.header__search details[open]') ||
        document.querySelector('#shopify-section-header .cosmoshop-header-drawer[open]') ||
        document.body.classList.contains('cosmoshop-search-open') ||
        document.body.classList.contains('cosmoshop-header-drawer-open') ||
        document.body.classList.contains('cosmoshop-cart-open') ||
        document.documentElement.classList.contains('cosmoshop-cart-open')
      );
    }

    function showHeader() {
      header.classList.add('shopify-section-header-sticky', 'animate');
      header.classList.remove('shopify-section-header-hidden');
      header.style.setProperty('transform', 'translate3d(0, 0, 0)', 'important');
    }

    function hideHeader() {
      header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      header.style.setProperty('transform', 'translate3d(0, -100%, 0)', 'important');
    }

    function resetHeader() {
      header.classList.remove('shopify-section-header-hidden');
      header.style.setProperty('transform', 'translate3d(0, 0, 0)', 'important');
    }

    function run() {
      var y = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      var delta = y - lastY;

      if (isLockedOpen()) {
        showHeader();
        lastY = y;
        return;
      }

      if (y <= 0) {
        resetHeader();
        lastY = y;
        return;
      }

      if (Math.abs(delta) < threshold) return;

      if (delta > 0 && y > hideAfter) {
        hideHeader();
      } else if (delta < 0) {
        showHeader();
      }

      lastY = y;
    }

    function requestRun() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        run();
        ticking = false;
      });
    }

    window.addEventListener('scroll', requestRun, { passive: true });
    window.addEventListener('resize', requestRun, { passive: true });
    document.addEventListener('toggle', requestRun, true);

    if ('MutationObserver' in window) {
      new MutationObserver(requestRun).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    run();
  }



  /* Lightweight, device-independent product status tag carousel. It only animates
     cards whose tags actually overflow, and batches all measurements into one frame. */
  var productStatusBadgeQueue = [];
  var productStatusBadgeQueued = [];
  var productStatusBadgeFrame = null;
  var productStatusBadgeResizeObserver = null;
  var productStatusBadgeIntersectionObserver = null;

  function isProductStatusBadgeQueued(container) {
    return productStatusBadgeQueued.indexOf(container) !== -1;
  }

  function queueProductStatusBadgeCarousel(container) {
    if (!container || !container.querySelector || isProductStatusBadgeQueued(container)) return;

    productStatusBadgeQueued.push(container);
    productStatusBadgeQueue.push(container);

    if (productStatusBadgeFrame !== null) return;
    productStatusBadgeFrame = window.requestAnimationFrame(flushProductStatusBadgeCarousels);
  }

  function clearProductStatusBadgeClones(track) {
    track.querySelectorAll('[data-product-status-badge-clone]').forEach(function(clone) {
      clone.remove();
    });
  }

  function configureProductStatusBadgeCarousel(container) {
    if (!container || !document.documentElement.contains(container)) return;

    var track = container.querySelector('.product-status-badges__track');
    if (!track) return;

    container.classList.remove('is-auto-rotating');
    track.style.removeProperty('--cosmoshop-badge-shift');
    track.style.removeProperty('--cosmoshop-badge-duration');
    clearProductStatusBadgeClones(track);

    var originalBadges = Array.prototype.slice.call(track.children);
    if (!originalBadges.length) return;

    var containerWidth = Math.ceil(container.clientWidth || 0);
    var originalWidth = Math.ceil(track.scrollWidth || 0);

    if (containerWidth <= 2 || originalWidth <= 2) {
      if (productStatusBadgeIntersectionObserver) {
        productStatusBadgeIntersectionObserver.observe(container);
      }
      return;
    }

    if (originalWidth <= containerWidth + 2) return;

    originalBadges.forEach(function(badge) {
      var clone = badge.cloneNode(true);
      clone.setAttribute('data-product-status-badge-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    var firstClone = track.querySelector('[data-product-status-badge-clone]');
    if (!firstClone) return;

    var cycleWidth = Math.ceil(firstClone.offsetLeft - originalBadges[0].offsetLeft);
    if (cycleWidth <= 0) {
      clearProductStatusBadgeClones(track);
      return;
    }

    var duration = Math.max(8, Math.min(18, cycleWidth / 18));
    track.style.setProperty('--cosmoshop-badge-shift', '-' + cycleWidth + 'px');
    track.style.setProperty('--cosmoshop-badge-duration', duration.toFixed(2) + 's');
    container.classList.add('is-auto-rotating');
  }

  function flushProductStatusBadgeCarousels() {
    productStatusBadgeFrame = null;
    var pending = productStatusBadgeQueue.slice();
    productStatusBadgeQueue.length = 0;
    productStatusBadgeQueued.length = 0;
    pending.forEach(configureProductStatusBadgeCarousel);
  }

  function observeProductStatusBadgeContainer(container) {
    if (!container || container.__cosmoshopBadgeObserved) return;
    container.__cosmoshopBadgeObserved = true;

    if (productStatusBadgeResizeObserver) {
      productStatusBadgeResizeObserver.observe(container);
    }

    if (productStatusBadgeIntersectionObserver) {
      productStatusBadgeIntersectionObserver.observe(container);
    }
  }

  function refreshProductStatusBadgeCarousels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = [];

    if (scope.matches && scope.matches('[data-product-status-badges]')) {
      containers.push(scope);
    }

    Array.prototype.push.apply(containers, scope.querySelectorAll('[data-product-status-badges]'));
    containers.forEach(function(container) {
      observeProductStatusBadgeContainer(container);
      queueProductStatusBadgeCarousel(container);
    });
  }

  function initProductStatusBadgeCarousels() {
    if (!productStatusBadgeResizeObserver && 'ResizeObserver' in window) {
      productStatusBadgeResizeObserver = new ResizeObserver(function(entries) {
        entries.forEach(function(entry) {
          queueProductStatusBadgeCarousel(entry.target);
        });
      });
    }

    if (!productStatusBadgeIntersectionObserver && 'IntersectionObserver' in window) {
      productStatusBadgeIntersectionObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          queueProductStatusBadgeCarousel(entry.target);
          productStatusBadgeIntersectionObserver.unobserve(entry.target);
        });
      }, { rootMargin: '160px 0px' });
    }

    refreshProductStatusBadgeCarousels(document);

    if (document.documentElement.dataset.cosmoshopProductStatusBadgesReady === 'true') return;
    document.documentElement.dataset.cosmoshopProductStatusBadgesReady = 'true';

    var refreshAll = debounce(function() {
      refreshProductStatusBadgeCarousels(document);
    }, 140);

    window.addEventListener('resize', refreshAll, { passive: true });
    window.addEventListener('orientationchange', refreshAll, { passive: true });
    window.addEventListener('pageshow', refreshAll, { passive: true });

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(refreshAll).catch(function() {});
    }
  }

  window.CosmoshopRefreshProductStatusBadgeCarousels = refreshProductStatusBadgeCarousels;

  ready(function() {
    initCosmoshopProductCountProgress();
    initCollectionSort();
    initSlideshows();
    initMobileDrawerStacking();
    initMobileSearchStacking();
    initCosmoshopSearchPlaceholder();
    /* Sticky header is controlled exclusively by sections/header.liquid. */
    initProductStatusBadgeCarousels();
  });

  document.addEventListener('shopify:section:load', function() {
    initSlideshows();
    initMobileDrawerStacking();
    initMobileSearchStacking();
    initCosmoshopSearchPlaceholder();
    /* Sticky header is controlled exclusively by sections/header.liquid. */
    initProductStatusBadgeCarousels();
  });
})();
